import { ToastId, useToast as useBaseToast, UseToastOptions } from '@chakra-ui/react';
import { useMemo } from 'react';

import { Toast } from '../components/toast';
import { ToastStatus } from '../types';

interface ToastFn {
	(options: UseToastOptions): ToastId | undefined;
	close: (id: ToastId) => void;
	closeAll: () => void;
}

const useToast = (): ToastFn => {
	const toast = useBaseToast();

	return useMemo(() => {
		const fn = ((options: UseToastOptions) =>
			toast({
				position: 'top-right',
				render: ({ status, title, description, ...rest }) => (
					<Toast isCloseable message={title as string} description={description as string | undefined} status={status as ToastStatus} {...rest} />
				),
				...options,
			})) as ToastFn;
		fn.close = toast.close;
		fn.closeAll = toast.closeAll;
		return fn;
	}, [toast]);
};

export { useToast };
